import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["emailField"]

    connect() {
        // Initialize the visibility based on the initial value
        this.toggleEmailField()
    }

    toggleEmailField() {
        const selectElement = this.element.querySelector('select')
        const selectedValue = selectElement.value

        if (selectedValue === "email") {
            this.emailFieldTarget.classList.remove("hidden")
        } else {
            this.emailFieldTarget.classList.add("hidden")
        }
    }
}
